export default [
  { key: 'id', val: 'Collection ID'},
  { key: 'account_ref', val: 'Account Reference' },
  { key: 'first_name', val: 'First Name'},
  { key: 'last_name', val: 'Last Name'},
  { key: 'external_tag', val: 'External Tag' },
  { key: 'status', val: 'Status' },
];
